import { StreamType, StreamUrl } from '~services/live/types';

/** The backend currently returns an additional HLS stream with CTR cipher mode that is not supported when generating clips, so it needs to be removed until supported. */
export const isStreamUrlValid = (type: StreamType, streamUrl: StreamUrl) =>
    type === 'HLS' ? streamUrl?.drm?.algorithm?.cipherMode !== 'CTR' : true;
